'use client';

import { useRouter } from 'next/navigation';

import { AppRoutes } from '@/constants/route';
import { useLogin, useRegistration } from '@/modules/authentication/application';

import { useToast } from '@packages/web-design-systems';

import { mapRegistrationFormToDto } from '../mappers/auth.mapper';
import type { RegistrationFormModel } from '../models/registration.form-model';

export const useRegistrationForm = () => {
	const router = useRouter();
	const { showError, showSuccess } = useToast();
	const registration = useRegistration();
	const login = useLogin();

	const execute = async (form: RegistrationFormModel) => {
		const dto = mapRegistrationFormToDto(form);
		const register = await registration.submit(dto);

		if (register.isFailure) {
			showError({ title: 'There was an error submitting the form. Please try again later.' });

			return;
		}

		const loggedIn = await login.submit({
			email:    form.email,
			password: form.password,
		});

		if (loggedIn.isFailure) {
			showError({ title: 'There was an error logging in. Please try to log in manually.' });
			router.push(AppRoutes.auth.login);

			return;
		}

		showSuccess({ title: 'Registration has been sent successfully!' });
		router.push(AppRoutes.auth.completeProfile);
	};

	return { execute };
};
